/**
 * Wywołania funkcji HTTP bota z Firebase ID tokenem zalogowanego użytkownika panelu.
 */

import { auth } from './firebase';
import { wywolajZTokenem } from './wywolanieZTokenem';

export const FUNCTIONS_BASE_URL: string =
  import.meta.env.VITE_FIREBASE_FUNCTIONS_URL ||
  'https://europe-central2-kamar-bot-production.cloudfunctions.net';

export class BrakSesjiPanelu extends Error {
  constructor() {
    super('Sesja panelu wygasła — zaloguj się ponownie.');
    this.name = 'BrakSesjiPanelu';
  }
}

export async function wywolajFunkcje(sciezka: string, init: RequestInit = {}): Promise<Response> {
  const uzytkownik = auth.currentUser;
  if (!uzytkownik) {
    throw new BrakSesjiPanelu();
  }
  const adres = `${FUNCTIONS_BASE_URL}/${sciezka.replace(/^\/+/, '')}`;
  return wywolajZTokenem(adres, init, (wymus) => uzytkownik.getIdToken(wymus));
}
